/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.InteracAddEmailResponse,
  addInteracEmail: (params: vp.InteracAddEmailRequest) => void,
  addInteracEmailAysnc: (params: vp.InteracAddEmailRequest) => Promise<vp.InteracAddEmailResponse>,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostAddInteracEmail: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldInteracMoneyRequest, setShouldInteracMoneyRequest] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.InteracAddEmailRequest>({
    PortalUser: '',
    RecipientName: '',
    RecipientEmailAddress: '',
    ClientControlled: false,
    ClientAccountID: '',
  });
  const [response, setResponse] = useState<vp.InteracAddEmailResponse>({
    Success: false,
    ErrorMessage: '',
    Token: '',
  });

  useEffect(() => {
    if (!shouldInteracMoneyRequest) return () => {};

    const PostInteracMoneyRequest = async () => {
      setDataFetchingInfo(true, 'processing', 'fullScreen');
      const res = await api.postAddInteracEmail(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldInteracMoneyRequest) void PostInteracMoneyRequest();
    setShouldInteracMoneyRequest(false);
    return () => {
      source.cancel();
    };
  }, [shouldInteracMoneyRequest]);

  return [
    response,
    (_params: vp.InteracAddEmailRequest) => {
      setParams(_params);
      setShouldInteracMoneyRequest(true);
    },
    async (_params: vp.InteracAddEmailRequest) => {
      try {
        setDataFetchingInfo(true);
        const res = await api.postAddInteracEmail(_params, source);

        return res;
      } finally {
        setDataFetchingInfo(false);
      }
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        Token: '',
      });
      setShouldInteracMoneyRequest(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostAddInteracEmail);
